import React from "react";

const Footer = () => {
  return (
    <footer className="bg-green-700 text-white py-4 text-center mt-6">
      <p>© 2025 गट ग्रामपंचायत खापरी-उबगी
 | संपर्क: +91-8554915167</p>
    </footer>
  );
};

export default Footer;